// combatpro/monster/useMonsterSelection.js
//
// Combat PRO - useMonsterSelection (Stage 61: Encounter Monster Selection Runtime).
//
// The thin consumer hook for the encounter monster-selection runtime. It returns the
// MonsterSelectionContext value - getAllMonsters / selectMonster / customPool /
// setCustomPool / selectionVersion - for any component or later runtime (the Stage
// 62 studio bridge, the monster-selection UI) that needs to look monsters up or
// insert one into an encounter slot.
//
// It owns nothing; the MonsterSelectionProvider is the single runtime owner. When
// used outside the provider it returns null, so callers can guard. No DOM, no
// fetch, no localStorage. No optional chaining. No em dash.

import { useContext } from 'react';
import { MonsterSelectionContext } from '../contexts/MonsterSelectionContext';

function useMonsterSelection() {
  return useContext(MonsterSelectionContext);
}

export default useMonsterSelection;
